export enum TipoFiltroRelatorios {
  tipoAtendimento = 1,
  areaAtuacao = 2,
  servidores = 3,
  defensorias = 4,
  defensores = 5,
  comarcas = 6,
  diretorias = 7,
  qualificacoes = 8,
}